/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Input, Select, Checkbox, Button, Radio, Drawer, Card, message, Tag, Tooltip } from "antd";
import PropertyService from "@/services/PropertiesService";
import IndustrialService from "@/services/IndustrialService";
import { useSearchParams } from "react-router-dom";
import PropertiesService from "@/services/PropertiesService";

const SearchBar = ({ onSearch }) => {
    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    const [searchText, setSearchText] = useState("");
    const [jobFields, setJobFields] = useState([]);
    const [industrial, setIndustrial] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [level, setLevel] = useState([]);
    const [salary, setSalary] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [workTime, setWorkTime] = useState([]);
    const [workType, setWorkType] = useState([]);
    const [language, setLanguage] = useState([]);
    const [selectedJobFields, setSelectedJobFields] = useState([]);
    const [selectedIndustrial, setSelectedIndustrial] = useState([]);
    const [selectedProvinces, setSelectedProvinces] = useState([]);

    const [selectedDistricts, setSelectedDistricts] = useState({});
    const [selectedLevel, setSelectedLevel] = useState({});
    const [selectedSalary, setSelectedSalary] = useState({});
    const [selectedJobs, setSelectedJobs] = useState({});
    const [selectedWorkTime, setSelectedWorkTime] = useState({});
    const [selectedWorkType, setSelectedWorkType] = useState({});
    const [selectedLanguage, setSelectedLanguage] = useState({});
    const [query, setQuery] = useState({});
    const [searchParams] = useSearchParams();

    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J001' }).then((res) => {
            setJobs(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu nghề nghiệp thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J002' }).then((res) => {
            setJobFields([{
                Code: "",
                Name: "Tất cả Lĩnh vực"
            }, ...res.Data]);
        }).catch((err) => {
            console.error('Lấy dữ liệu lĩnh vực thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J003' }).then((res) => {
            setProvinces([{
                Code: "",
                Name: "Tất cả Tỉnh / Thành"
            }, ...res.Data]);
        }).catch((err) => {
            console.error('Lấy dữ liệu tỉnh thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J004' }).then((res) => {
            setDistricts([{
                Code: "",
                Name: "Tất cả Quận / Huyện"
            }, ...res.Data]);
        }).catch((err) => {
            console.error('Lấy dữ liệu quận huyện thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertyService.getFilter({ ParentCode: 'J006' }).then((res) => {
            setLevel(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu cấp bậc thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J007' }).then((res) => {
            setWorkTime(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu giờ làm thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J008' }).then((res) => {
            setWorkType(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu hình thức làm việc thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J009' }).then((res) => {
            setSalary(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu mức lương thất bại', err)
        })
    }, []);
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J010' }).then((res) => {
            setLanguage(res.Data);
        }).catch((err) => {
            console.error('Lấy dữ liệu ngoại ngữ thất bại', err)
        })
    }, []);
    useEffect(() => {
        IndustrialService.getIndustrial().then((res) => {
            setIndustrial([{
                CodeKcn: "",
                NameKcn: "Tất cả Khu công nghiệp"
            }, ...res.Data]);
        }).catch((err) => {
            console.error('Lấy dữ liệu khu công nghiệp thất bại', err)
        })
    }, []);

    useEffect(() => {
        if (searchParams.get('input_search')) setSearchText(searchParams.get('input_search'))
        if (searchParams.get('districtId')) setSelectedDistricts(districts.find(e => e.Code === searchParams.get('districtId')))
        if (searchParams.get('levelId')) setSelectedLevel(level.find(e => e.Code === searchParams.get('levelId')))
        if (searchParams.get('salaryId')) setSelectedSalary(salary.find(e => e.Code === searchParams.get('salaryId')))
        if (searchParams.get('nghenghiepId')) setSelectedJobs(jobs.find(e => e.Code === searchParams.get('nghenghiepId')))
        if (searchParams.get('giolamId')) setSelectedWorkTime(workTime.find(e => e.Code === searchParams.get('giolamId')))
        if (searchParams.get('worktypeId')) setSelectedWorkType(workType.find(e => e.Code === searchParams.get('worktypeId')))
        if (searchParams.get('ngoainguId')) setSelectedLanguage(language.find(e => e.Code === searchParams.get('ngoainguId')))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams.toString(), districts, level, salary, jobs, workTime, workType, language, selectedJobFields, selectedProvinces, selectedIndustrial]);

    useEffect(() => {
        const temp = {};
        if (!!searchText !== "") temp.input_search = searchText;
        if (!!selectedJobFields?.Code) temp.linhvucId = selectedJobFields?.Code;
        if (!!selectedIndustrial?.Code) temp.kcnId = selectedIndustrial?.Code;
        if (!!selectedProvinces?.Code) temp.locationId = selectedProvinces?.Code;
        if (!!selectedDistricts?.Code) temp.districtId = selectedDistricts?.Code;
        if (!!selectedLevel?.Code) temp.levelId = selectedLevel?.Code;
        if (!!selectedSalary?.Code) temp.salaryId = selectedSalary?.Code;
        if (!!selectedJobs?.Code) temp.nghenghiepId = selectedJobs?.Code;
        if (!!selectedWorkTime?.Code) temp.giolamId = selectedWorkTime?.Code;
        if (!!selectedLanguage?.Code) temp.ngoainguId = selectedLanguage?.Code;
        if (!!selectedWorkType?.Code) temp.worktypeId = selectedWorkType?.Code;
        setQuery(temp);
    }, [searchText, selectedDistricts, selectedIndustrial, selectedJobFields, selectedJobs, selectedLanguage, selectedLevel, selectedProvinces, selectedSalary, selectedWorkTime, selectedWorkType]);

    // Modules
    const queryParams = useMemo(() => {
        return Object.fromEntries(searchParams.entries());
    }, [searchParams.toString()]);

    useEffect(() => {
        setQuery(queryParams)
    }, [queryParams]);

    const handleReset = () => {
        setSelectedDistricts({});
        setSelectedLevel({});
        setSelectedSalary({});
        setSelectedJobs({});
        setSelectedWorkTime({});
        setSelectedWorkType({});
        setSelectedLanguage({});
        setQuery({})
        message.success('Đã bỏ chọn tất cả', 1);
    }

    const handleSearch = () => {
        onSearch(query);
    }

    const renderDropdownContent = () => (
        <div>
            <div className={"p-2 -mb-4"}>
                <Select
                    className="w-full md:w-full h-14 border-none rounded-lg p-2 focus:outline-none focus:ring focus:ring-green-200"
                    showSearch
                    placeholder='Tất cả Quận / Huyện'
                    options={districts}
                    value={selectedDistricts?.Code}
                    onChange={(e, option) => setSelectedDistricts(option)}
                    fieldNames={{ value: 'Code', label: 'Name' }}
                    optionFilterProp={'Name'}
                />
            </div>
            <div className={"p-[16px] w-full"}>
                <div
                    className="flex flex-wrap gap-4 justify-between">

                    {/* Cấp bậc */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">CẤP BẬC</h4>
                        <Radio.Group
                            className="h-72 overflow-auto"
                            value={selectedLevel}
                        >
                            {level.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedLevel?.Code === e.Code) {
                                        setSelectedLevel()
                                    } else {
                                        setSelectedLevel(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>

                    {/* Mức lương */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">MỨC LƯƠNG</h4>
                        <Radio.Group
                            className="h-72 overflow-auto"
                            value={selectedSalary}
                        >
                            {salary.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedSalary?.Code === e.Code) {
                                        setSelectedSalary()
                                    } else {
                                        setSelectedSalary(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>

                    {/* Nghề nghiệp */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">NGHỀ NGHIỆP</h4>
                        <Radio.Group
                            className="h-72 overflow-auto"
                            value={selectedJobs}
                        >
                            {jobs.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedJobs?.Code === e.Code) {
                                        setSelectedJobs()
                                    } else {
                                        setSelectedJobs(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>

                    {/* Giờ làm */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">GIỜ LÀM</h4>
                        <Radio.Group
                            className="h-72 overflow-auto"
                            value={selectedWorkTime}
                        >
                            {workTime.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedWorkTime?.Code === e.Code) {
                                        setSelectedWorkTime()
                                    } else {
                                        setSelectedWorkTime(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>

                    {/* Ngoại ngữ */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">NGOẠI NGỮ</h4>
                        <Radio.Group
                            value={selectedLanguage}
                        >
                            {language.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedLanguage?.Code === e.Code) {
                                        setSelectedLanguage()
                                    } else {
                                        setSelectedLanguage(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>

                    {/* Hình thức làm việc */}
                    <div
                        className={"border border-gray-300 p-4 rounded-lg"}
                        style={{
                            flex: "1 1 calc(25% - 16px)", // Mỗi cột chiếm 1/4 không gian, trừ khoảng cách
                        }}
                    >
                        <h4 className="font-semibold mb-2">HÌNH THỨC LÀM VIỆC</h4>
                        <Radio.Group
                            value={selectedWorkType}
                        >
                            {workType.map(e => (
                                <Radio key={e.Code} value={e} onClick={() => {
                                    if (selectedWorkType?.Code === e.Code) {
                                        setSelectedWorkType()
                                    } else {
                                        setSelectedWorkType(e)
                                    }
                                }}>
                                    {e.Name}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>
                </div>

                {/* Footer */}
                <div className="mt-4 flex justify-between">
                    <Button
                        type="text"
                        className="text-green-600 hover:text-green-800 border border-red-900 hover:transition-colors"
                        onClick={handleReset}
                    >
                        Bỏ chọn tất cả
                    </Button>
                </div>
            </div>
        </div>
    );

    return (
        <div className={"bg-white"}>
            <div className="container mx-auto flex items-center flex-wrap gap-4 p-4">

                {/* Tên công việc, vị trí */}
                <div className={"flex flex-1 gap-4"}>
                    <Input
                        allowClear
                        value={query.input_search}
                        onChange={(e) => setQuery({ ...query, input_search: e.target.value })}
                        placeholder="Tên công việc, vị trí"
                        className="flex-1 border min-w-56 border-gray-300 rounded-lg h-12 focus:outline-none focus:ring focus:ring-green-200" />

                </div>
                {/* loc */}
                <div className="hidden lg:flex md:flex-wrap flex-1 !items-center md:gap-4">
                    <Select
                        className="!w-full !flex !items-center !justify-center min-w-56 h-12 "

                        mode={'multiple'}
                        maxTagCount="responsive"
                        tagRender={
                            (props) => {
                                const { label, onClose } = props;
                                return (
                                    <Tag
                                        className="!flex !items-center !justify-center"
                                        style={{ height: "100% ", marginTop: '8px' }}
                                    >
                                        {label}
                                    </Tag>
                                );
                            }
                        }
                        // allowClear
                        fieldNames={{ value: 'Pk', label: 'Name' }}
                        options={[...new Set([...districts, ...jobFields, ...salary, ...level, ...jobs, ...workTime, ...workType, ...language])]}
                        value={[selectedDistricts?.Pk, selectedJobFields?.Pk, selectedSalary?.Pk, selectedLevel?.Pk, selectedJobs?.Pk, selectedWorkTime?.Pk, selectedWorkType?.Pk, selectedLanguage?.Pk].filter(e => !!e)}

                        maxTagPlaceholder={(omittedValues) => (
                            <Tooltip
                                styles={{ root: { pointerEvents: 'none' } }}
                                title={omittedValues.map(({ label }) => label).join(', ')}
                            >
                                <span className="cursor-pointer">...</span>
                            </Tooltip>
                        )}

                        placeholder={(
                            <div className="translate-y-2">
                                <i className="fa-solid fa-filter text-lg text-green-600"></i>
                                <span className="font-medium">Lọc nâng cao</span>
                            </div>
                        )}
                        style={{ width: 250 }}
                        dropdownStyle={{ width: "810px" }} // Đặt kích thước lớn hơn cho dropdown
                        dropdownRender={renderDropdownContent}
                    />
                </div>
                {/* Danh mục Nghề mobile */}
                <div className={"lg:hidden flex flex-1"}>
                    <Button
                        onClick={showDrawer}
                        className="border h-12 min-w-56 w-full border-gray-300 rounded-lg p-2 focus:outline-none"
                    >
                        <i className="fa-solid fa-filter text-lg text-green-600"></i>
                        <span className="font-medium">Lọc nâng cao</span>
                    </Button>
                    <Drawer
                        title={<span className="text-xl font-bold text-green-900">Bộ lọc nâng cao</span>}
                        onClose={onClose}
                        open={open}
                        size={"large"}
                        styles={{
                            body: { padding: "20px", backgroundColor: "#809D3C" },
                            header: { backgroundColor: "#5D8736", borderBottom: "none" },
                        }}
                    >
                        <div className={"flex flex-col gap-4"}>
                            <Card className="container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]">
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Ngành nghề</label>
                                    <div className="relative flex-1">
                                        <Select className={"w-full"}
                                            value={selectedJobs?.Code}
                                            options={jobs}
                                            placeholder='Chọn ngành nghề'
                                            onChange={(e, option) => setSelectedJobs(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card className="container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]">
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Cấp bậc</label>
                                    <div className="relative flex-1">
                                        <Select className={"w-full"}
                                            value={selectedLevel?.Code}
                                            options={level}
                                            placeholder="Chọn cấp bậc"
                                            onChange={(e, option) => setSelectedLevel(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card className="container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]">
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Hình thức làm
                                        việc</label>
                                    <div className="relative flex-1">
                                        <Select className={"w-full"}
                                            value={selectedWorkType?.Code}
                                            options={workType}
                                            placeholder='Chọn hình thức làm việc'
                                            onChange={(e, option) => setSelectedWorkType(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card
                                className={"container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]"}>
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Giờ làm</label>
                                    <div className="relative">
                                        <Select className={"w-full"}
                                            value={selectedWorkTime?.Code}
                                            options={workTime}
                                            placeholder='Chọn giờ làm'
                                            onChange={(e, option) => setSelectedWorkTime(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card className="container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]">
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Mức lương</label>
                                    <div className="relative">
                                        <Select className={"w-full"}
                                            value={selectedSalary?.Code}
                                            options={salary}
                                            placeholder="Chọn mức lương"
                                            onChange={(e, option) => setSelectedSalary(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card
                                className={"container mx-auto rounded-3xl border border-green-700 bg-[#A9C46C]"}>
                                <div className="flex flex-col gap-2">
                                    <label className="text-lg font-medium text-gray-800">Ngoại ngữ</label>
                                    <div className="relative">
                                        <Select className={"w-full"}
                                            value={selectedLanguage?.Code}
                                            options={language}
                                            placeholder='Chọn ngoại ngữ'
                                            onChange={(e, option) => setSelectedLanguage(option)}
                                            fieldNames={{ value: 'Code', label: 'Name' }}
                                            optionFilterProp={'Name'}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <div className="flex justify-center gap-4">
                                <Button
                                    onClick={handleReset}
                                    className="border h-10 border-gray-300 rounded-lg p-2 focus:outline-none"
                                >
                                    <span className="font-medium">Bỏ chọn</span>
                                </Button>
                            </div>
                        </div>
                    </Drawer>
                </div>
                {/* Lĩnh vực */}
                <div className={"flex flex-1 gap-4"}>
                    <Select
                        className="w-full min-w-56 h-12 border-none rounded-lg focus:outline-none focus:ring focus:ring-green-200"
                        showSearch
                        placeholder="Tất cả lĩnh vực"
                        options={jobFields}
                        onChange={(e) => setQuery({ ...query, linhvucId: e })}
                        fieldNames={{ value: 'Code', label: 'Name' }}
                        optionFilterProp={'Name'}
                        value={query.linhvucId}
                    />
                </div>
                {/*KCN*/}
                <div className={"flex flex-1 gap-4"}>
                    <Select
                        className="w-full min-w-56 h-12 border-none rounded-lg focus:outline-none focus:ring focus:ring-green-200"
                        showSearch
                        placeholder="Tất cả Khu công nghiệp"
                        options={industrial}
                        onChange={(e) => setQuery({ ...query, kcnId: e })}
                        fieldNames={{ value: 'CodeKcn', label: 'NameKcn' }}
                        optionFilterProp={'NameKcn'}
                        value={query.kcnId}
                    />
                </div>
                {/* Tỉnh/Thành phố */}
                <div className={"flex flex-1 gap-4"}>
                    <Select
                        className="w-full min-w-56 h-12 border-none rounded-lg focus:outline-none focus:ring focus:ring-green-200"
                        showSearch
                        placeholder="Tất cả Tỉnh / Thành"
                        options={provinces}
                        onChange={(e) => setQuery({ ...query, locationId: e })}
                        fieldNames={{ value: 'Code', label: 'Name' }}
                        optionFilterProp={'Name'}
                        value={query.locationId}
                    />
                </div>
                {/* Nút Tìm kiếm */}
                <button
                    onClick={handleSearch}
                    className="h-12 min-w-40  flex-1 font-bold  bg-gradient-to-l bg-primary hover:bg-primary-hover text-white rounded-lg   transition w-full md:w-auto">
                    Tìm kiếm
                </button>
            </div>
        </div>
    );
}
    ;

export default SearchBar;
